var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockedMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "91px",
    viewBox: "0 0 100 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Page/Blocked Members") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Profile-&-Settings-\\uD83D\\uDC81\\uD83C\\uDFFB\\u200D\\u2640\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blocked-Members---Empty",
    transform: "translate(-137.000000, -209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Page/Blocked-Members",
    transform: "translate(71.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(70.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blocked-members-empty-icon",
    stroke: "#CCCCCC",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7178538,0 C52.2870055,0 63.2869764,11.0199459 63.2869764,24.613738 C63.2869764,33.1479554 58.9514915,40.6677271 52.366633,45.0831537 C66.0987038,50.5464765 75.9251698,63.7437205 76.4907488,79.3082431 L-7.51425341e-06,79.3082431 C0.573802711,63.5172009 10.6800196,50.1628435 24.7255798,44.8483905 C18.33411,40.4047697 14.1487311,32.9989152 14.1487311,24.613738 C14.1487311,11.0199459 25.148702,0 38.7178538,0 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(53.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    fill: "#710D0D",
    cx: 21.5670103,
    cy: 21.5280899,
    rx: 21.4329897,
    ry: 21.4719101
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "#FFFFFF",
    x: 9.31958763,
    y: 18.4606742,
    width: 25.5154639,
    height: 6.13483146
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedMembers);
export default __webpack_public_path__ + "static/media/blocked-members.295d35d7d1719d3f14dc3509f2307aa1.svg";
export { ForwardRef as ReactComponent };